import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Paper, Grid, Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CmpProjectStatusIcon from './CmpProjectStatusIcon';
import ChanceStatusIcon from '../../chancemng/info/ChanceStatusIcon';
import { getNumberComma } from '../../../utils/numberUtils';

const WhiteIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: theme.palette.getContrastText(
      theme.palette.background.paper,
    ),
  },
}));

const WhiteTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.background.paper,
}));

//chance와 project 를 모두 사용함.
const CmpProjectInfo = ({ project, handleGoBack }) => {
  const [projectStatus, setProjectStatus] = useState('');

  useEffect(() => {
    if (project) {
      if (project?.cmpGrade && project?.cmpGrade > 0) {
        setProjectStatus(project.cmpStatus);
      } else {
        setProjectStatus(project.cstStatus);
      }
    }
  }, [project]);

  return (
    <Paper
      sx={{
        mx: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          backgroundColor: '#424242',
        }}
      >
        <Box sx={{ p: 1 }}>
          <WhiteIconButton size="small" onClick={handleGoBack}>
            <ArrowBackIcon aria-label="goBack" />
          </WhiteIconButton>
        </Box>
        <Box
          sx={{
            py: 1,
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          {project?.cmpGrade && project.cmpGrade > 0 ? (
            <CmpProjectStatusIcon project={project} />
          ) : (
            <ChanceStatusIcon chance={project} />
          )}
          <Box sx={{ ml: 2 }}>
            <WhiteTypography variant="subtitle2" component="div">
              현재 단계: {projectStatus}
            </WhiteTypography>
            <WhiteTypography variant="subtitle1" component="div">
              {project.cstNm}
            </WhiteTypography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ px: 2, py: 2 }}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={3} align="center">
            <Typography variant="subtitle2" component="div">
              프로젝트 번호
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="subtitle2" component="div">
              매출처명
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="subtitle2" component="div">
              매출 예상일
            </Typography>
          </Grid>
          <Grid item xs={2} align="center">
            <Typography variant="subtitle2" component="div">
              예상 금액
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={3} align="center">
            <Typography variant="body2" component="div">
              {project?.prjNo}
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="body2" component="div">
              {project?.vendorCmpNm}
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="body2" component="div">
              {project.expDay ? project?.expDay : `-`}
            </Typography>
          </Grid>
          <Grid item xs={2} align="center">
            <Typography variant="body2" component="div">
              {getNumberComma(project?.expSales)}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default CmpProjectInfo;
